import { render, staticRenderFns } from "./NotifyModal.vue?vue&type=template&id=0d9d9f20"
import script from "./NotifyModal.vue?vue&type=script&lang=js"
export * from "./NotifyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports